export const routes = (parentName) => {
  return [
    {
      path: "side",
      component: () => import("./Index.vue"),
      children: [
        {
          path: "",
          name: `${parentName}-Side`,
          component: () => import("./List.vue"),
          props: (route) => ({
            step: route.query.step,
          }),
        },
        {
          path: "",
          name: `${parentName}-Side-List`,
          component: () => import("./List.vue"),
          props: (route) => ({
            step: route.query.step,
          }),
        },

        {
          path: "special",
          name: `${parentName}-Side-List-Special`,
          component: () => import("./ListSpecial.vue"),
          props: (route) => ({
            step: route.query.step,
          }),
        },
        {
          path: "new",
          name: `${parentName}-Side-New`,
          component: () => import("./Upsert.vue"),
        },

        {
          path: ":id/edit",
          name: parentName + "-" + "Side-Edit",
          component: () => import("./Upsert.vue"),
        },
      ],
    },
  ];
};
